import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, classBorderLabelDark, classBt, classbtAzul, classbtCeuAzul, classbtCinzaClaro, classbtColunasAzul, classBtSemDuration, classDivBackground,
    classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, Clientes, ClientesSearchBox, ContaAReceber
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { ClientesService } from "../Clientes/ClientesService"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { IoPrint, IoSearch } from "react-icons/io5"
import { ContaAReceberService } from "./ContaAReceberService"
import { Funcoes } from "../../Utils/Funcoes"
import moment from "moment"
import { ReportContaReceberPDF } from "./pdf/report-contaReceber"
import { TbReport } from "react-icons/tb"
import { GridRelContaAReceberDia } from "../../Components/GridProducts/GridRelContaAReceberDia"
import { FaVideo } from "react-icons/fa"
import { ModalTutorial } from "../../Components/Modal/modal-tutorial"
import { AiOutlineClear } from "react-icons/ai"
import { RelContaReceberGeralPDF } from "./pdf/rel-contaReceberGeral"


export const ContaAReceberRelatorios = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(31, 'days')
        .format('YYYY-MM-DD')


    // -----------------------------------------------
    // ---------- ATRIBUTOS FEEDBACK -----------------
    // -----------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")


    // -----------------------------------------------
    // ------------- ATRIBUTOS -----------------------
    // -----------------------------------------------
    const [dadosRelCtaReceber, setDadosRelCtaReceber] = useState<ContaAReceber[]>([])

    const [clientes, setClientes] = useState<ClientesSearchBox[]>([])
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])
    const [idCliente, setIdCliente] = useState(0)

    const [datai, setDatai] = useState<string>(dateI)
    const [dataf, setDataf] = useState<string>(dateF)

    const [tipo_filtro, setTipo_Filtro] = useState("A")

    // -----------------------------------------------
    // ------------- DADOS DUPLICATA -----------------
    // -----------------------------------------------
    const [qtdDup, setQtdDup] = useState(0)
    const [totDup, setTotDup] = useState(0)

    // -----------------------------------------------
    // ------------- SEARCHBOX -----------------------
    // -----------------------------------------------
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getClientes = async () => {
        setLoading(true)

        try {

            const resp = await ClientesService.GetListCliente()
            setClientes(resp.data)
            setClientesList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar os clientes")

        } finally {
            setLoading(false)
        }
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }
    }, [])

    useEffect(() => {
        getClientes()
    }, [])

    useEffect(() => {
        setQtdDup(0)
        setTotDup(0)

    }, [tipo_filtro])

    //------------------------------------------------------------- FUNÇÕES DE PESQUISAR ----------------------------------------------------------------------------------------------//
    const calcularTotal = (ctaReceberList: ContaAReceber[], incluirValorOriginal: boolean = true) => {

        const hoje = new Date()
        const taxaPadrao = parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
        const dias = Number(localStorage.getItem("@ecommerce/diasJuros") || 0)
        let total = 0

        ctaReceberList.forEach(({ data_vencimento, valor_original }: any) => {
            const vencimentoBase = new Date(data_vencimento)

            // Soma os dias
            const vencimento = new Date(vencimentoBase)
            vencimento.setDate(vencimento.getDate() + 1 + dias)
            let juros = 0

            if (data_vencimento && vencimento < hoje) {
                const hojeZero = new Date(hoje)
                hojeZero.setHours(0, 0, 0, 0)

                const vencZero = new Date(vencimento)
                vencZero.setHours(0, 0, 0, 0)

                const diffTime = hojeZero.getTime() - vencZero.getTime()
                const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0)

                if (diffDias > 0) {
                    const taxaPercent = taxaPadrao || 0        // ex.: 5 = 5% ao mês
                    const taxaDiaria = (taxaPercent / 100) / 30 // proporcional ao mês
                    juros = valor_original * taxaDiaria * diffDias // juros simples
                }
            }

            total += incluirValorOriginal ? (valor_original + juros) : juros

        })

        return parseFloat(total.toFixed(2))
    }

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)

        try {

            //setTotSelecionado(0)

            setDadosRelCtaReceber([])
            setQtdDup(0)
            setTotDup(0)

            searchBoxFocus()

            const relatorio = {
                id_cliente: idCliente,
                datai: datai,
                dataf: dataf,
                tipo_filtro: tipo_filtro
            }

            const dados = await ContaAReceberService.Filter(relatorio)

            if (dados.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(dados.msg || "")

            } else {
                //setCtaReceberList(dados.data.ctaReceber)
                setQtdDup(dados.data.qtdDup)

                let totalDupJuros = calcularTotal(dados.data.ctaReceber)

                setTotDup(totalDupJuros)

                setDadosRelCtaReceber(dados.data.ctaReceber)
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possivel buscar os dados")

        } finally {
            setLoading(false)
        }



    }

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRec") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !visibleSearchBoxCliente && menuFiltro.classList.contains("max-h-[1000px]") && !loading) {
            await handleFilterClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [datai, dataf, idCliente, tipo_filtro, visibleSearchBoxCliente, loading])

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeTipoFiltro = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo_Filtro(e.target.value)
    }

    const handleLimparFiltros = () => {

        setIdCliente(0)
        setDatai(dateI)
        setDataf(dateF)
        setTipo_Filtro("A")

        setVisible(false)
        searchBoxFocus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- CLIENTE ------------------------------------------------------------------------------------------//
    const handleClearClienteSelecionado = useCallback(() => {
        const newClienteList = [...clientes || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [clientes])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        if (v) {
            const newClienteList = [...clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)
    }, [clientes])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    const searchBoxFocus = () => {
        setVisibleSearchBoxCliente(false)
    }

    //------------------------------------------------------------- PDF ------------------------------------------------------------------------------------------------------------------------------------//
    const handleGerarPDFClick = async (event: any) => {

        setVisible(false)

        try {

            let mostrarColuna = tipo_filtro === 'A' ? false : true
            let totDupJuros = calcularTotal(dadosRelCtaReceber)

            const pdf = new RelContaReceberGeralPDF(dadosRelCtaReceber, qtdDup, totDupJuros, mostrarColuna)
            pdf.GerarPDF(dadosRelCtaReceber)

            event.currentTarget.blur()

        } catch (error) {

            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage("Não foi possivel fazer a impressão. Por favor, tente novamente")
                clearTimeout(timer)
            }, 250)

        }
    }

    // --------------------------------------------------------------------- FILTROS -----------------------------------------------------------------------
    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRec") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsDupRec") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                //setSearchBoxResponsivo(true)
                menuInputs.classList.remove("invisible")


            } else {

                //setSearchBoxResponsivo(false)
                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }
    }

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 md:col-span-8 flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0`}>

                            <div className="flex flex-row">

                                <TbReport className={`mx-2 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Duplicatas a receber - relatórios</span>

                            </div>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>

                        </div>

                        <div className={`relative col-span-6 md:col-span-2`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 md:col-span-2`}>
                            <button tabIndex={-1} className={`${classBt} ${classbtCeuAzul} h-9 disabled:bg-opacity-50 disabled:cursor-not-allowed`} disabled={!(dadosRelCtaReceber.length > 0)} onClick={handleGerarPDFClick}>
                                <IoPrint size="20px" className={`mr-2 hidden md:block`} /> Imprimir
                            </button>
                        </div>

                    </div>

                    <div id='divInputsDupRec' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroDupRec' className={`relative max-h-[0px] h-[510px] sm:h-[300px] xl:h-[230px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-4 py-7 px-3`}>

                            <div className={`relative col-span-12 xl:col-span-4 2xl:col-span-6 mt-1`}>
                                <SearchBox
                                    dataList={clientesList}
                                    label='Cliente'
                                    clearDataClick={handleClearClienteSelecionado}
                                    setDataClick={handleClienteSelectClick}
                                    filterDataClick={handleFilterClienteClick}
                                    idRegistro={idCliente || undefined}
                                    visibleTAB={visibleSearchBoxCliente}
                                    clicado={clickSearchBoxCliente}
                                    componentId='cliente'
                                />

                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                <input id='data-inicial' className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onFocus={searchBoxFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="data-inicial" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipo_filtro === 'A' ? 'Data de Vencimento Inicial' : 'Data da Baixa Inicial'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-1`}>
                                <input id='data-final' className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onFocus={searchBoxFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="data-final" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipo_filtro === 'A' ? 'Data de Vencimento Final' : 'Data da Baixa Final'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2 mt-1`}>
                                <select id="status" className={`${classInput} ${classInputDark} `} value={tipo_filtro} onFocus={searchBoxFocus} onChange={handleChangeTipoFiltro}>
                                    <option value="A" className={`text-slate-900 dark:text-slate-200`}>Abertas</option>
                                    <option value="L" className={`text-slate-900 dark:text-slate-200`}>Liquidadas</option>
                                </select>
                                <label htmlFor="status" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-1`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>

                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>

                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className='flex flex-col justify-start w-full h-auto bg-gray-200 border rounded-md md:flex-row md:py-2 border-slate-500 dark:bg-slate-700'>

                                    <div className="w-full md:w-[50%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400">
                                        <span className="w-full md:w-auto">N° Duplicatas: </span>
                                        <span className="flex items-center justify-end w-full md:w-auto md:ml-2">{qtdDup}</span>
                                    </div>

                                    <div className="w-full md:w-[50%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400">
                                        <span className="w-full md:w-auto">Total: </span>
                                        <span className="flex items-center justify-end w-full md:w-auto md:ml-2">{Funcoes.numberFormat(totDup, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridRelContaAReceberDia duplicata={dadosRelCtaReceber} tipo={tipo_filtro === "L" ? "L" : "A"} />
                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_relDupReceber.mp4'
                            title='Como gerar um relatório de duplicatas a receber'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>

    )
}